import React from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { useEffect } from 'react';
import apiService from '../../services/api.service';
import { useState } from 'react';
import { MethodOfPayment, OrderStatus } from '../../data/enums';
import CountdownTimer from '../../components/CountdownTimer';
import { useTranslation } from '../../hooks/useTranslation';


function CompanyRegistrationForm({
    loading,
    company,
    selectMopMsg,
    companyUser,
    orderStatusId,
    getPaymentHTML,
    expirationTime,
    setOrderStatusId,
    RDRCT_TIME_IN_MS,
    expirationTimeTxt,
    productBlockingIdentifier
}) {
    const { t } = useTranslation();

    const [companyMops, setCompanyMops] = useState([])
    useEffect(() => {
        if (companyUser) {
            getCompanyMops()
        }
    }, [])
    const getCompanyMops = () => {
        apiService.getCompanyMops(company.companyId).then((r) => {
            setCompanyMops(r.data.data)
        })
    }
    const displayCompanyMops = () => {
        if (companyMops) {
            return companyMops.map((c) => {
                return ['radio'].map((type) => (
                    <div key={`reverse-${type}`} className="mb-3 ">
                        {
                            c.mopType === MethodOfPayment.CreditCard &&
                            <Form.Check
                                reverse
                                label={t("CreditCardAndConfirm")}
                                name="group1"
                                type={type}
                                onClick={() => setOrderStatusId(OrderStatus.InProcess)}
                                id="credit-card"
                            />
                        }
                        {
                            c.mopType === MethodOfPayment.BankTransfer &&
                            <Form.Check
                                reverse
                                label={t("BankTransfer")}
                                onClick={() => setOrderStatusId(OrderStatus.Pending)}
                                name="group1"
                                type={type}
                                id="transfer"
                            />
                        }
                    </div>
                ))

            })
        }
    }
    return (
        <div className="box reg-form" id="reg">
            <h2 className="top-line">
                <Row> <Col>{t("UserDetails")} </Col> <Col className="secured-pay-wrap"><span className="pay-icn"> </span> <span className="pay-txt">{t("SecurePay")}</span></Col></Row>
            </h2>
            {!!productBlockingIdentifier &&
                <div className="count-down-wrap">
                    <div role="application" aria-roledescription={t("Attention")} aria-label={t("ExpirationText").replace("[0]", expirationTimeTxt)}>{t("ExpirationText").replace("[0]", expirationTimeTxt)} </div>
                    <span role="application" aria-roledescription={t("Attention")} aria-label={t("RemainedExpirationTimeText") + (new Date(RDRCT_TIME_IN_MS).getMinutes() + " " + t("Mins")) + " " + (new Date(RDRCT_TIME_IN_MS).getSeconds() - 3 + " " + t("Seconds"))}>{t("RemainedExpirationTimeText")}</span>
                    <CountdownTimer targetDate={expirationTime} />
                </div>
            }

            <div className="comp-contact-form">
                <div className="input-field">
                    <label htmlFor="contact-email">{t("Email")}</label><br />
                    <input type="text" id="contact-email" className="pe-2 ps-2" defaultValue={companyUser.customerEmail} disabled />
                </div>

                <div className="input-field">
                    <label htmlFor="company-name">{t("CompanyName")}</label><br />
                    <input type="text" id="company-name" className="pe-2 ps-2" defaultValue={company.companyName} disabled />
                </div>

                <div className="input-field">
                    <label htmlFor="bn-number">{t("BnNumber")}</label><br />
                    <input type="text" id="bn-number" className="pe-2 ps-2" defaultValue={company.companyVatNumber} disabled />
                </div>
            </div>
            <>
                {companyMops &&
                    <div className="side-paddings">
                        <h3 aria-label={t("ChoosePaymentMethod")} className="comp-gift-to">{t("ChoosePaymentMethod")}</h3>
                        {displayCompanyMops()}
                        <Row className="stick-btns">
                            <Col sm={12} className="book-btn text-start"><button disabled={loading} aria-label={t("Book")} className="btn long order-btn" onClick={e => getPaymentHTML()}>{loading && <Spinner className="spinner" animation="border" />}{orderStatusId == OrderStatus.Pending ? t("ConfirmDetailsAndComplete") : t("ConfirmDetailsAndProceed")}</button></Col>
                            <span role="alert" className="text-danger bold text-center pb-3">{selectMopMsg}</span>
                        </Row>
                    </div>
                }
            </>
        </div>
    )
}

export default CompanyRegistrationForm